import {Map, Record, type RecordOf} from 'immutable';
import {FileRecord} from '@packages/systems/core/records/FileRecord';
import {
  SiteRolesType,
  WorkspaceRolesType,
} from '@packages/domains/authorization/permissions/catalog';
import type {DesignerStores} from '@packages/systems/designer/flux';
import type {Authorizations} from '@packages/domains/identity-and-access/role-based-access/data-types';

export {getFormattedNameForUser} from './utils/getFormattedNameForUser';

export type UsersMapType = Map<string, RecordOf<UserRecordType>>;

export type UserRecordType = {
  _id: string | null;
  authorizations: Authorizations | null;
  email: string | null;
  emailHash: string | null;
  firstName: string | null;
  lastName: string | null;
  usernameRaw: string | null;
  profileImg:
    | string
    | null
    | {
        url: string;
        file: FileRecord;
      };
  user: string | null;
  editorCapabilities: string | null;
  roles: {
    site: SiteRolesType;
    siteRoleId?: string | null;
    workspace: WorkspaceRolesType;
  } | null;
};

export const UserRecord = Record<UserRecordType>(
  {
    _id: null,
    authorizations: null,
    email: null,
    emailHash: null,
    firstName: null,
    lastName: null,
    usernameRaw: null,
    profileImg: null,
    user: null,
    editorCapabilities: null,
    roles: null,
  },
  'UserRecord'
);

type UserStateShape = {
  users: UsersMapType;
  siteUsers: UsersMapType;
  siteDesigners: UsersMapType;
  isAuthenticated: boolean | null | undefined;
  isUserServiceProvider: boolean | null | undefined;
  firstName: string | null | undefined;
  lastName: string | null | undefined;
  email: string | null | undefined;
  role: any | null | undefined;
  isUserInOrg: boolean | null | undefined;
  plan: any;
  planForReadOnly: any;
  canCreateMoreSites: any;
  maxUnhostedSites: number | null | undefined;
  onboardingSiteId: string | null;
  userId: string | null;
  isEmailVerified: boolean | null;
  // TODO: Remove after legacy editor shutoff (Aug 4, 2026).
  legacyEditorMigrated: boolean | null;
};

export const getSiteUsersSelector = (state: DesignerStores): UsersMapType =>
  state.UserStore.siteUsers;

export type UserState = RecordOf<UserStateShape>;
